export { SlidingTab } from './SlidingTab';
